import { VERTICAL_EMBED_TYPE } from './consts';
import VerticalSearchModule from './VerticalSearchModule';
export default function verticalEmbedStrategy(instance) {
    var _a;
    if (!instance)
        return {};
    return {
        config: (_a = {},
            _a[VERTICAL_EMBED_TYPE] = {
                verticalsApi: function (type, locale) {
                    if (locale === void 0) { locale = 'en'; }
                    return new VerticalSearchModule(type, instance, locale);
                },
                getIsVisiblePromise: function (type, locale) {
                    if (locale === void 0) { locale = 'en'; }
                    return new VerticalSearchModule(type, instance, locale).isInstalled();
                },
            },
            _a),
    };
}
//# sourceMappingURL=verticalEmbedStrategy.js.map